import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["columns", "columnConfigurator", "customTableComponentProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Builders
import CellConfig from '../../builders/TableInputField.cellConfig';
import ColumnConfig from '../../builders/TableInputField.columnConfig';

// Components
import ActionCellRenderer from '../../cellRenderers/ActionCellRenderer';

// Helpers
import { getColumnsWithActions } from './withTableActions.helpers';
var ACTION_COLUMN_WIDTH = 52;
var withTableActions = function withTableActions(WrappedComponent) {
  var WithTableActions = /*#__PURE__*/function (_Component) {
    _inherits(WithTableActions, _Component);
    var _super = _createSuper(WithTableActions);
    function WithTableActions(props) {
      var _this;
      _classCallCheck(this, WithTableActions);
      _this = _super.call(this, props);
      var _props$rowActionProps = props.rowActionProps,
        _props$rowActionProps2 = _props$rowActionProps.title,
        title = _props$rowActionProps2 === void 0 ? '' : _props$rowActionProps2,
        _props$rowActionProps3 = _props$rowActionProps.width,
        width = _props$rowActionProps3 === void 0 ? ACTION_COLUMN_WIDTH : _props$rowActionProps3,
        _props$rowActionProps4 = _props$rowActionProps.className,
        className = _props$rowActionProps4 === void 0 ? '' : _props$rowActionProps4,
        _props$rowActionProps5 = _props$rowActionProps.headerClassName,
        headerClassName = _props$rowActionProps5 === void 0 ? '' : _props$rowActionProps5;
      _this.actionCellConfig = new ColumnConfig('action').setTitle(title).setWidth(width || ACTION_COLUMN_WIDTH).setClassName(className).setHeaderClassName(headerClassName).setFixed('right').addCellConfig(new CellConfig().setComponent(function (cellComponentProps) {
        return /*#__PURE__*/React.createElement(ActionCellRenderer, _extends({}, cellComponentProps, {
          showKebabAlways: props.showKebabAlways
        }));
      })).setMapCellPropsToComponentProps(props.getActionsForRow);
      return _this;
    }
    _createClass(WithTableActions, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          columns = _this$props.columns,
          _this$props$columnCon = _this$props.columnConfigurator,
          columnConfigurator = _this$props$columnCon === void 0 ? EMPTY_OBJECT : _this$props$columnCon,
          customTableComponentProps = _this$props.customTableComponentProps,
          restProps = _objectWithoutProperties(_this$props, _excluded);
        var columnsWithAction = getColumnsWithActions(columns, _objectSpread(_objectSpread({}, this.actionCellConfig), columnConfigurator));
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
          customTableComponentProps: customTableComponentProps
        }, restProps, {
          columns: columnsWithAction
        }));
      }
    }]);
    return WithTableActions;
  }(Component);
  WithTableActions.propTypes = {
    getActionsForRow: PropTypes.func,
    customTableComponentProps: PropTypes.func,
    columns: PropTypes.array,
    showKebabAlways: PropTypes.bool,
    rowActionProps: PropTypes.object,
    columnConfigurator: PropTypes.object
  };
  WithTableActions.defaultProps = {
    getActionsForRow: _noop,
    customTableComponentProps: _noop,
    columns: EMPTY_ARRAY,
    showKebabAlways: false,
    rowActionProps: EMPTY_OBJECT,
    columnConfigurator: EMPTY_OBJECT
  };
  return WithTableActions;
};
export default withTableActions;